import {INav} from 'features/layout/redux/helpers/FoldersHelper';
import produce from 'immer';
import {findLastIndex, findIndex, get} from 'lodash';
import {IDiplomatObject} from 'types/DiplomatObject';
import {DiplomatObjectType} from 'types/DiplomatObjectType';

export function decimalToHexString(number: number) {
   if (number < 0) {
      number = 0xff + number + 1;
   }

   return number.toString(16).toUpperCase();
}

export function base64ToHexString(str: string) {
   const raw = atob(str);
   let result = '';
   for (let i = 0; i < raw.length; i++) {
      const hex = raw.charCodeAt(i).toString(16);
      result += hex.length === 2 ? hex : '0' + hex;
   }
   return result.toUpperCase();
}

export const currentLocationIsLogin = () => window.location.pathname === '/login';

export const getDirectory = (path: string) => {
   const i = findLastIndex(path, (chr) => chr === '/' || chr === '\\');
   return i === -1 ? '' : path.substring(0, i);
};

export const getFilename = (path: string) => {
   const i = findLastIndex(path, (chr) => chr === '/' || chr === '\\');
   return i === -1 ? '' : path.substring(i + 1);
};

export const updateInArray = (arr: any[], obj: any, fieldToCompare: string) => {
   let newArr = arr;
   const i = findIndex(newArr, (o) => get(o, fieldToCompare) === get(obj, fieldToCompare));
   if (i >= 0) {
      newArr = [...arr];
      newArr[i] = obj;
   }
   return newArr;
};

export const removeLatest = (arr: any[], comparator: (val: any) => boolean) => {
   let newArr = arr;
   const i = findLastIndex(arr, comparator);
   if (i >= 0) {
      newArr = [...arr];
      newArr.splice(i, 1);
   }
   return newArr;
};

export function ensureValueInArray<T>(array: T[], value: T) {
   if (array.indexOf(value) === -1) {
      array.push(value);
   }
}

export function objectWithDeletedItem<T extends {[k: string]: any}>(obj: T, key: string) {
   const item = {...obj};
   delete item[key];
   return item;
}

export const filterByObjectType = (objects: IDiplomatObject[] | undefined, type: string) => {
   if (!objects) {
      return [];
   }
   return objects.filter((object: IDiplomatObject) => object.objectType === type);
};

export const swapArrayElements = (array: any, index1: number, index2: number) => {
   const resultArray = array.slice();
   [resultArray[index1], resultArray[index2]] = [resultArray[index2], resultArray[index1]];
   return resultArray;
};

export const flattenKeys = function (tree: object) {
   const leaves = [] as string[];
   const walk = function (obj: any, path?: string) {
      path = path || '';
      const sep = path ? '.' : '';
      for (const n in obj) {
         if (obj.hasOwnProperty(n)) {
            if (typeof obj[n] === 'object' || obj[n] instanceof Array) {
               walk(obj[n], path + sep + n);
            } else {
               leaves.push(path + sep + n);
            }
         }
      }
   };
   walk(tree);
   return leaves;
};

export const mutateVfsNode = produce(
   (draft: INav[], _path: string, mutator: (obj: INav) => void) => {
      const path = String(_path);
      // console.debug(draft[0].child);
      const serverDraft = draft[0].child?.find(
         (n1) => n1.childObjectType === DiplomatObjectType.enum.SFTP_SERVER
      );
      const vfsRootDraft = (serverDraft || draft[0]).child?.find(
         (n2) => n2.childObjectType === DiplomatObjectType.enum.VFS
      );

      let target: INav | undefined;
      const findInnerTarget = (obj: INav, path: string): INav | undefined | false => {
         if (target) {
            return false;
         }
         // console.debug('findInnerTarget', obj.id, id, obj.name);
         if (get(obj, 'path') === path) {
            target = obj;
            return false;
         }
         if (obj.child) {
            obj.child.forEach((child) => findInnerTarget(child, path));
         }
      };
      if (vfsRootDraft) {
         findInnerTarget(vfsRootDraft, path);
         // console.debug('vfs target', JSON.stringify(target));
         target && mutator(target);
      }
   }
);

export const delay = (time: number) => new Promise((res) => setTimeout(res, time));

export const speedBytes = function (bytes: number, seconds: number) {
   var speed = seconds ? (bytes * 8) / seconds : 0;
   return speed;
};

export const formatSpeed = function (speed: number) {
   var units = [' bps', ' kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
   var unitNum = 0;
   while (speed > 1024) {
      speed = speed / 1024;
      unitNum++;
   }
   return Math.max(speed, 0.1).toFixed(2) + units[unitNum];
};

export const mbps = function (bytes: number, seconds: number) {
   var speed = seconds ? (bytes * 8) / seconds : 0;
   var units = [' bps', ' kbps', ' Mbps', ' Gbps', ' Tbps', 'Pbps', 'Ebps', 'Zbps', 'Ybps'];
   var unitNum = 0;
   while (speed > 1024) {
      speed = speed / 1024;
      unitNum++;
   }
   return Math.max(speed, 0.1).toFixed(2) + units[unitNum];
};

export const logWrapper = (fn: Function) => (...args: any) => {
   console.debug(args);
   const result = fn(args);
   console.debug(result);
   return result;
};
